"use strict";
exports.__esModule = true;
var earth_1 = require("./earth");
var spherical_mercator_1 = require("../projection/spherical-mercator");
var transformation_1 = require("../transformation");
var util_1 = require("@antv/util");
var scale = 0.5 / (Math.PI * spherical_mercator_1.sphericalMercator.R);
var transform = new transformation_1.Transformation(scale, 0.5, -scale, 0.5);
// @ts-ignore
exports.epsg3857 = util_1.mix({}, earth_1.earth, {
    code: 'EPSG:3857',
    projection: spherical_mercator_1.sphericalMercator,
    transformation: transform
});
exports.epsg900913 = util_1.mix({}, exports.epsg3857, {
    code: 'EPSG:900913'
});
//# sourceMappingURL=crs-epsg3857.js.map